import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import Overlay from '../Overlay';
import ErrorModal from '../ErrorModal';
import CartonGuidesHeader from './components/CartonGuide/CartonGuidesHeader';
import ManifestActions from './components/ManifestActions';
import useCartonGuides from './hooks/useCartonGuides';
import ManifestGuides from './components/ManifestGuides';

export default function CartonGuide({ cartonId, concludeClassificationUrl }) {
  const actionsRef = useRef(null);
  const listRef = useRef(null);

  const {
    data: {
      guides,
      scans,
      guidesFree,
      scansFree,
      guidesExcept,
      scansExcept,
      error
    },
    actions: {
      onScan,
      clearError
    }
  } = useCartonGuides(
    cartonId,
    () => {
      actionsRef.current.focusScanner();
      listRef.current.scrollToPosition(0);
    },
    () => {
      actionsRef.current.blurScanner();
    }
  );

  const onCloseError = () => {
    clearError();
    actionsRef.current.focusScanner();
  };

  return (
    <div className="manifest h-100 d-flex flex-column">
      <CartonGuidesHeader
        totalGuides={guides.length}
        totalScans={scans}
        totalGuidesFree={guidesFree}
        totalScansFree={scansFree}
        totalGuidesExcept={guidesExcept}
        totalScansExcept={scansExcept}
        concludeClassificationUrl={concludeClassificationUrl}
      />
      <ManifestActions ref={actionsRef} onScan={onScan} />
      <ManifestGuides guides={guides} listRef={listRef} />
      <Overlay show={!!error}>
        <ErrorModal
          error={error}
          onClose={onCloseError}
        />
      </Overlay>
    </div>
  );
}

CartonGuide.propTypes = {
  cartonId: PropTypes.number.isRequired,
  concludeClassificationUrl: PropTypes.string.isRequired
};
